export const text =
`
I wrote a book called Gambit Queen...
`
